module.exports={Remove:"Poista"};